// Keep the weight gate separate from Melon's existing minimum-order validation.
// Fresh Liquid button markup releases this gate; this script never enables a button.
(() => {
  if (window.sawasdealCheckoutWeightLimitInitialized) return;
  window.sawasdealCheckoutWeightLimitInitialized = true;

  const selector = 'button[data-sd-checkout-overweight="true"]';
  const enforce = () => {
    document.querySelectorAll(selector).forEach((button) => {
      if (!button.disabled) button.disabled = true;
    });
  };

  enforce();
  new MutationObserver(enforce).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['disabled', 'data-sd-checkout-overweight'],
  });

  // Also block a programmatic submission through the same cart form while overweight.
  document.addEventListener('submit', (event) => {
    if (event.target.id !== 'cart' && event.target.id !== 'CartDrawer-Form') return;
    const button = document.querySelector(`${selector}[form="${event.target.id}"]`);
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    enforce();
  }, true);
})();
